export type Audience = {
  unitAudience: string[];
  roleAudience: string[];
  countryAudience: string[];
};

export enum DocumentsEntryTypes {
  WORK_CONTRACT_TEMPLATE = 'WORK_CONTRACT_TEMPLATE',
  WORK_CERTIFICATE_TEMPLATE = 'WORK_CERTIFICATE_TEMPLATE',
}

export type DocumentType = {
  fDocumentId: number;
  fDocumentName: string;
  fDocumentDocType: string;
  fDocumentDescription: string;
  fDocumentAttachment: File | undefined;
  fDocumentApprovalStatus?: string;
  fDocumentCreated: string;
  fDocumentModified: string;
  fDocumentExpirationDate?: string;
  fDocumentEmpId?: number;
  fDocumentOwnerId?: number;
  fDocumentOwnerType?: string;
  fDocumentDocReadOnly?: boolean;
  fDocumentSize?: number;
  fDocumentSha1Hash?: string;
  fDocumentAudience?: Audience;
};

export type EmployeeFormType = {
  fEmpFormId: number;
  fEmpFormEmpId: number;
  fEmpFormCompFormFK: number;
  fEmpFormCreatedTime: string;
  fEmpFormUpdatedTime: string;
  fEmpFormInfo?: string;
  fEmpFormAttachmentId: number;
  fEmpFormAttachmentName: string;
  fEmpFormAttachmentIsArchived: boolean;
  fFormAttachment?: File | undefined;
};

export type CompanyFormType = {
  fComFormId: number;
  fComFormName: string;
  fComFormCountry: string;
  fComFormCreatedTime: string;
  fComFormUpdatedTime: string;
  fComFormIsActive: boolean;
  fComFormExpirationDate: string;
  fComFormAttachmentId: number;
  fComFormAttachmentName: string;
  fComFormAttachmentIsArchived: boolean;
  fComFormDescription?: string;
};
